export default "__VITE_ASSET__Czr2L5if__"